export { PerformanceInstrumentation } from './instrumentation';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/performance/index.ts